const MOJIBAKE_PATTERN = /[ÃƒÃ˜Ã™Ã‚]/;
const QUESTION_MARK_ONLY_PATTERN = /^[\s?؟._-]+$/;

const CP1252_EXTENSION_MAP = {
  8364: 128,
  8218: 130,
  402: 131,
  8222: 132,
  8230: 133,
  8224: 134,
  8225: 135,
  710: 136,
  8240: 137,
  352: 138,
  8249: 139,
  338: 140,
  381: 142,
  8216: 145,
  8217: 146,
  8220: 147,
  8221: 148,
  8226: 149,
  8211: 150,
  8212: 151,
  732: 152,
  8482: 153,
  353: 154,
  8250: 155,
  339: 156,
  382: 158,
  376: 159
};

function toCp1252Bytes(value) {
  return Uint8Array.from(
    Array.from(value, (char) => {
      const codePoint = char.codePointAt(0);

      if (codePoint <= 255) {
        return codePoint;
      }

      return CP1252_EXTENSION_MAP[codePoint] ?? 63;
    })
  );
}

function decodeUtf8Bytes(bytes) {
  const percentEncoded = Array.from(bytes, (byte) => `%${byte.toString(16).padStart(2, "0")}`).join("");
  return decodeURIComponent(percentEncoded);
}

export function repairMojibakeText(value) {
  if (typeof value !== "string" || !MOJIBAKE_PATTERN.test(value)) {
    return value;
  }

  let repaired = value;

  for (let attempt = 0; attempt < 3; attempt += 1) {
    try {
      const decoded = decodeUtf8Bytes(toCp1252Bytes(repaired)).split("\u0000").join("");

      if (!decoded || decoded === repaired) {
        break;
      }

      repaired = decoded;
    } catch (error) {
      break;
    }
  }

  return repaired;
}

export function repairMojibakeDeep(value) {
  if (Array.isArray(value)) {
    return value.map((item) => repairMojibakeDeep(item));
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, currentValue]) => [key, repairMojibakeDeep(currentValue)])
    );
  }

  return repairMojibakeText(value);
}

export function hasMeaningfulText(value) {
  if (typeof value !== "string") {
    return false;
  }

  const trimmed = repairMojibakeText(value).trim();
  if (!trimmed) {
    return false;
  }

  return !QUESTION_MARK_ONLY_PATTERN.test(trimmed);
}

function formatEmailPrefix(email) {
  const prefix = String(email || "").split("@")[0].trim();
  if (!prefix) {
    return "";
  }

  return prefix
    .replace(/[._-]+/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function getPreferredDisplayName(user, fallback = "User") {
  const repairedName = repairMojibakeText(user?.full_name || "");
  if (hasMeaningfulText(repairedName)) {
    return repairedName.trim();
  }

  const emailBasedName = formatEmailPrefix(user?.email);
  if (emailBasedName) {
    return emailBasedName;
  }

  return fallback;
}
